import Column from "./Column";
import Icon from "./Icon";
import PropTypes from "prop-types";
import React, { useState } from "react";
import Row from "./Row";
import { TextTitle } from "./Texts";
import AccountSelector from "./AccountSelector";
import colors from "../styles/colors";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import mainSelectors from "../modules/main/selectors";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { ThreeDotsVertical } from "styled-icons/bootstrap";
import packageJson from "package.json";

const HeaderMobile = ({ onMenuClicked, extraPage }) => {
  const [t, i18n] = useTranslation();
  let history = useHistory();
  const authAdproResult = useSelector((state) => mainSelectors.authAdproResult(state));
  const currentDashboard = useSelector((state) => mainSelectors.currentDashboardResult(state));
  const { REACT_APP_RMP_HELP_CONTACT } = process.env;
  const [isOptionsVisible, setOptionsVisible] = useState(false);

  let textHead = currentDashboard.data.dashboard === "google" ? "Google" : "Meta";

  if (extraPage) {
    textHead = t("__noads_setting_button");
  }

  const goContact = () => {
    history.push("/contact");
  };

  const handleShowMore = () => {
    setOptionsVisible(!isOptionsVisible);
  };

  const onDropdownItemSelected = () => {
    setOptionsVisible(false);
  };

  const DropdownItem = ({ item, index, onClick }) => {
    return (
      <>
        {item.type === "item" && (
          <StyledItem onClick={() => onClick(item, index)}>
            <CallLink href={`tel:${REACT_APP_RMP_HELP_CONTACT}`}>
              <div className="icon-circle bg-blue">
                <StylePhone src="/images/call.svg" />
              </div>
              <div className="menu-info">
                <h4>{item.title}</h4>
              </div>
            </CallLink>
          </StyledItem>
        )}
        {item.type === "version" && (
          <VersionItem>
            <div className="version-text">Version: {item.title}</div>
          </VersionItem>
        )}
      </>
    );
  };

  let items = [
    { type: "item", title: t("__open_contact") },
    { type: "version", title: `${packageJson.version}` },
  ];
  const viewItems = () =>
    items.map((item, index) => (
      <DropdownItem key={index} item={item} index={index} onClick={() => onDropdownItemSelected()}></DropdownItem>
    ));

  return (
    <StyledContainer>
      <Row alignItems="center">
        <Column wrap>
          {authAdproResult.result === 0 || authAdproResult.result === 1 || authAdproResult.result === 2 ? (
            <Icon name="icon-menu" color={colors.white} onClick={onMenuClicked} />
          ) : (
            ""
          )}
        </Column>
        <Column className="app-title-container">
          <TextTitle align="left" color={colors.white}>
            {textHead}
          </TextTitle>
        </Column>
        <Column wrap>
          {authAdproResult.result === 0 &&
          currentDashboard.data.dashboard === "google" &&
          authAdproResult.data.adwords_managed_service === "Y" ? (
            <Icon name="icon-phone" color={colors.white} onClick={goContact} />
          ) : (
            ""
          )}
        </Column>
        <Column wrap>
          <div className="rmp-widget" id="rmp_widget" data-source-app-id="1"></div>
        </Column>
        <MoreContainer>
          <StyleThreeDotsVertical size="16" onClick={handleShowMore} />
          <ItemsContainer isVisible={isOptionsVisible} position={{ top: "30px", right: "0" }} minWidth={"300px"}>
            {viewItems()}
          </ItemsContainer>
          {isOptionsVisible && <Backdrop onClick={() => setOptionsVisible(false)} />}
        </MoreContainer>
      </Row>
    </StyledContainer>
  );
};

HeaderMobile.propTypes = {
  onMenuClicked: PropTypes.func,
};

export default HeaderMobile;

const StyledContainer = styled.div`
  background-color: ${colors.primary};
  box-shadow: ${colors.sectionShadow} 0 10px 30px;
  padding: 16px;
  border-radius: 0 0 0px 0px;
  position: absolute;
  z-index: 99;
  left: 0;
  right: 0;
  top: 0;

  @media screen and (max-width: 834px) {
    margin: 0 0px 24px !important;

    .app-title-container {
      margin-right: -28px !important;
    }
  }
`;

const MoreContainer = styled.div`
  position: relative;
  display: inline-block;

  > *:first-child {
    cursor: pointer;
  }
`;

const ItemsContainer = styled.div.attrs((props) => ({
  display: props.isVisible ? "block" : "none",
  top: props.position ? props.position.top : "35px",
  right: props.position && props.position.right ? props.position.right : null,
  minWidth: props.minWidth,
}))`
  display: ${(props) => props.display};
  position: absolute;
  background-color: ${colors.backgroundSection};
  box-shadow: ${colors.sectionShadow} 0 10px 30px;
  z-index: 999;
  top: ${(props) => props.top};
  right: ${(props) => props.right};
  min-width: ${(props) => props.minWidth};
  text-align: left;
  overflow: auto;
  margin: 2px 0;
  left: auto;
  border-radius: 10px;
`;

const StyledItem = styled.div`
  cursor: pointer;
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 998;
`;

const StyleThreeDotsVertical = styled(ThreeDotsVertical)`
  color: ${colors.white};
  cursor: pointer;
  width: 18px;
  height: 18px;
`;

const StylePhone = styled.img`
  cursor: pointer;
  width: 16px;
  height: 16px;
  line-height: 36px;
  position: relative;
  top: -16px;
`;

const CallLink = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  text-decoration: none;
  overflow: hidden;
  padding: 7px 11px;
  transition: 0.5s;
  .menu-info {
    display: inline-block;
    position: relative;
    left: 10px;
  }

  h4 {
    margin: 0;
    font-size: 13px;
    color: #333;
  }

  .icon-circle {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    color: #2196f3 !important;
    text-align: center;
    display: inline-block;
  }

  .bg-blue {
    background-color: #2196f3 !important;
  }

  &:hover {
    color: #23527c;
    background-color: #e9e9e9;
  }
`;

const VersionItem = styled.div`
  border-top: 1px solid #ddd;
  padding: 5px;
  font-size: 10px;
  .version-text {
    height: 20px;
    line-height: 20px;
    font-size: 10px;
    text-align: right;
    color: #8f8f8f;
  }
`;
